import PropTypes from "prop-types"

import { GridContainer } from "areas/collection/products"
import CollectionProduct from "areas/collection/products/collection-product"

import ItemImage from "./item-image"

const CollectionItems = ({ items, lazyload, linkClickData }) => (
  <GridContainer>
    {items.map((item, index) =>
      item.type === "product" ? (
        <CollectionProduct
          index={index}
          key={`collection_item_${item.style_code || index}`}
          linkClickData={linkClickData}
          product={item}
        />
      ) : item.type === "image" ? (
        <li
          className="relative mb-24 px-8 text-center"
          key={`collection_item_${item.style_code || index}`}
        >
          <ItemImage
            image={item.image}
            lazyload={lazyload}
            linkClickData={linkClickData}
          />
        </li>
      ) : null
    )}
  </GridContainer>
)

CollectionItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  lazyload: PropTypes.bool,
  linkClickData: PropTypes.string,
}

export default CollectionItems
